import React, { useState, useEffect, useRef } from 'react';
//ANTD
import { Select } from 'antd';
//API
import userAPI from '../../../../API/user.service.api';

import parse from 'html-react-parser';

import { useSelector } from 'react-redux';
//INTL
import { FormattedMessage, useIntl } from 'react-intl';

//CONST
const { Option } = Select;

const FriendsSelect = (props) => {
  const { isLoggedIn } = useSelector((store) => store.authentication);
  const [dataFriends, setDataFriends] = useState([]);
  const [value, setValue] = useState(undefined);
  const { member = [] } = props;
  const ref = useRef(null);

  useEffect(() => {
    if (!isLoggedIn) {
      setValue(undefined);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (props.authUser && props.authUser.id && member.length === 0) {
      userAPI
        .getFriendsById(props.authUser.id)
        .then((res) => {
          const { code, friends } = res;
          if (code === 200) {
            setDataFriends(friends);
          } else {
            console.log(res);
          }
        })
        .catch((err) => console.log(err));
    } else if (member.length > 0) {
      setDataFriends(props.member);
    } else {
      setDataFriends([]);
    }
  }, [props.authUser]);

  const intl = useIntl();

  return (
    <Select
      value={value}
      ref={ref}
      placeholder={intl.formatMessage({
        id: 'Friends tour',
        defaultMessage: 'Friends tour',
      })}
      style={{ width: '200px' }}
      size="small"
      onSelect={(value, option) => {
        props.getFriendToursShortInfoById(props.authUser.id, value);
        setValue(value);
      }}
      notFoundContent={intl.formatMessage({
        id: 'No friends',
        defaultMessage: 'No friends',
      })}
      dropdownClassName={props.className ? props.className : ''}
    >
      <Option value="empty" key={0}></Option>
      {dataFriends.map((item) => (
        <Option value={item.id} key={item.id}>
          {parse(item.name)}
        </Option>
      ))}
    </Select>
  );
};

export default FriendsSelect;
